import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ApproximateTxnsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getApproximateTransactions(req);
    }
}
export default ApproximateTxnsUseCase;
